import { gql } from "@apollo/client";

export const GET_ENROLLMENT_PERIOD_ENUMS = gql`
  query GetEnrollmentPeriodEnums {
    enrollment_period(where: { deleted_at: { _is_null: true } }) {
      id
      enrollment_period_tags {
        id
        name
      }
      grades {
        school_id
      }
    }
  }
`;

export const FETCH_PRIORITY_TEMPLATES = gql`
  query FetchPriorityTemplates($order_by: priority_template_order_by!) {
    priority_template(order_by: [$order_by]) {
      id
      name
      enrollment_period {
        name
        organization {
          name
        }
      }
    }
  }
`;

export const FETCH_PRIORITY_TEMPLATE_BY_ID = gql`
  query FetchPriorityTemplateById($id: uuid!) {
    priority_template_by_pk(id: $id) {
      id
      name
      config
      sort_field_1
      sort_field_2
      sort_field_3
      sort_order_1
      sort_order_2
      sort_order_3
      enrollment_period_id
      priority_template_schools {
        school_id
      }
      priority_template_grades {
        grade_id
        grade {
          school_id
        }
      }
    }
  }
`;
